import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import {IPatient, Patient} from '../Patient.ts';
import {HealthcareFacilitiesApi} from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import {useSessionProvider} from '../../../provider/sessionContext.tsx';

export function useGetClinicPatients() {
    const {currentUser} = useSessionProvider();

    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.clinicPatients, currentUser?.selectedHealthcareFacilityID],
        queryFn: async () => {
            const result: IPatient[] = await HealthcareFacilitiesApi.getClinicPatients(
                currentUser!.selectedHealthcareFacilityID!
            );
            return result ? result.map((x) => new Patient(x)) : result;
        },
        enabled: !!currentUser && !!currentUser?.selectedHealthcareFacilityID
    });
}
